<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-10 18:51:23
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-22 18:10:57
 * @FilePath: \mrc-base-server-view\src\views\data-access-strategy\index.vue
-->
<template>
  <div>
    <!--!hasBtn('add-data-strategy') -->
    <mrc_ess_table
      :headers="headers"
      :hideAddBtn="true"
      v-if="$route.name == 'data-access-strategy'"
      pageName="data-access-strategy-add"
      :paginationOptions="paginationOptions"
      @turnPage="getList"
      :isLoading="loading"
      :slotKey="['strategy_number', 'org_level_name']"
      :items="desserts"
    >
      <!-- <template v-slot:search>
        <v-row
          class="d-flex justify-end"
          style="background: white;
          margin: 0;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;padding: 0 16px"
        >
          <mrc_ess_advanceFilterAndSearchInput
            class="mt-4"
            v-model="systemSeniorQueryString"
            @success="getList({ cpage: 1 })"
            :systemFieldMeta="systemFieldMeta"
          ></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template> -->
      <template v-slot:item.org_level_name="{ item }">
        <span>{{ INT(item.org_level_name) }}</span>
      </template>

      <template v-slot:item.strategy_number="{ item }">
        <span
          v-for="(item1, index) in item.strategy_number.split(',')"
          :key="index"
        >
          <mrc_ess_chip v-if="item1" class="mr-1">{{ item1 }}</mrc_ess_chip>
        </span>
      </template>

      <template v-slot:item.actions="{ item }">
        <menu-list :list="menulist" @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon
              v-btnAuth="[
                'edit-data-strategy',
                'add-data-strategy',
                'delete-data-strategy',
              ]"
              >mdi-dots-vertical</v-icon
            >
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators"
import { listData, delData } from "@/service/api/data-access-strategy"
export default {
  components: {},
  props: {},
  data() {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      desserts: [],
      loading: false,
      paginationOptions: {
        pagesize: this.$store.state.pageSize,
        cpage: this.$store.state.cpage,
        totalcount: 0, //总条数
        totalpage: 0, //总页数
      },
    }
  },
  validations: {},
  computed: {
    menulist() {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("edit-data-strategy"),
          type: "view",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("add-data-strategy"),
          type: "edit",
        },
        {
          name: this.$t("label_delete"),
          // show: this.hasBtn('delete-data-strategy'),
          show: false,
          type: "del",
        },
      ]
    },
    headers() {
      return [
        {
          text: this.$t("label_Use_the_unit"),
          align: "start",
          sortable: false,
          value: "org_level_name",
        },
        {
          text: this.$t("label_data_strategy"),
          align: "start",
          sortable: false,
          value: "strategy_number",
        },
        {
          text: " ",
          align: "end",
          sortable: false,
          value: "actions",
        },
      ]
    },
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1)
  },
  async created() {
    await this.getBtnPermissionList()
  },
  watch: {
    async $route(val) {
      if (val.name == "data-access-strategy") {
        await this.getList(this.paginationOptions)
      }
    },
  },
  async mounted() {
    await this.getList()
  },
  beforeDestroy() {},
  methods: {
    async getList(obj) {
      this.loading = true
      if (
        this.desserts.length == 1 &&
        this.paginationOptions.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.paginationOptions.cpage--
      if (obj) {
        this.paginationOptions = { ...this.paginationOptions, ...obj }
      }
      this.desserts = []
      const res = await listData({
        cpage: this.paginationOptions.cpage,
        pagesize: this.paginationOptions.pagesize,
        org_level_uuid: this.$store.state.currentCompany,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })
      if (res.code == 200) {
        this.desserts = res.data
        this.paginationOptions.totalcount = res.totalcount
        this.paginationOptions.totalpage = res.totalpage
        this.systemFieldMeta = res.systemFieldMeta
        this.field_alias_name = res.field_alias_name
        this.table_alias_name = res.table_alias_name
      }
      this.loading = false
    },
    handleClick({ index, item }, obj) {
      if (item.type == "view") {
        this.$store.commit("set_subPage_name", obj.org_level_name)
        this.$store.commit("set_uuid", obj.org_level_uuid)
        this.$store.commit("set_iconstatus", true) //行内进图标显示
        this.$router.push({
          name: "data-access-strategy-detail",
          params: {
            name: obj.org_level_uuid,
            uuid: obj.uuid,
          },
        })
      }
      // 编辑
      if (item.type == "edit") {
        this.$store.commit("set_subPage_name", obj.org_level_name)
        this.$store.commit("set_uuid", obj.org_level_uuid)
        this.$store.commit("set_iconstatus", false)
        this.$router.push({
          name: "data-access-strategy-detail",
          params: {
            name: obj.org_level_uuid,
            uuid: obj.uuid,
          },
        })
      }
      if (item.type == "del") {
        this.$myConfirm({ content: this.$t("message_Confirm_the_deletion") })
          .then(async () => {
            const del = await delData({
              org_level_uuid: obj.org_level_uuid,
            })
            if (del.code == 200) {
              // this.$Message({ text: this.$t('message_The_deletion_was_successful') })
              this.$Message({
                text: this.$t("message_The_deletion_was_successful"),
              })
              // this.desserts.length === 1  只有一条数据 删除就请求上一页的数据
              if (
                this.desserts.length === 1 &&
                this.paginationOptions.cpage > 1
              ) {
                this.paginationOptions.cpage--
              }
              await this.getList()
            }
          })
          .catch(() => {})
      }
    },
  },
}
</script>

<style scoped>
.procedure_name {
  display: flex;
  flex-direction: column;
  padding: 10px 0;
}
.name {
  font-size: 16px;
}
.desc {
  color: #aaaaaa;
}
</style>
